<div class="loading-wrapper" *ngIf="data">
    <div class="loader">
        <div class="loader-figure"></div>
        <div class="loader-label">
            <p>{{ data.text }}</p>
        </div>
    </div>
</div>
